module.exports = __webpack_public_path__ + "media/images/project/add-rule-0acd5012058ceb7b2cc5a99688b5577a.svg";